import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicCrewDto extends EpimsBaseEntityDto {
  CrewName: string;
  CrewNumber: number;
  ContractorId: string;
  SubscriberEmail: string;
  SubscriptionUserId: string;
  Version: number;
}
